const RECAPTCHA_V2 = window.config.RECAPTCHA_V2;

module.exports = function MissedDelivery(shopperService, missedDeliveryService, googleCaptchaService, settingsService, $timeout, element) {
    return {
        restrict: 'E',
        scope: true,
        template: require('./misseddelivery-template.html'),
        link(scope) {
            scope.loading = false;
            scope.showError = false;
            scope.showReCaptcha = false;
            scope.showReCaptchaErrorMessage = false;
            scope.resheduleDeliveryReferenceNumber = null;
            scope.recaptchaV2Key = RECAPTCHA_V2;

            settingsService.getSettingValue('GoogleReCaptcha', 'EnableGoogleReCaptchaNew').then(function (response) {
                scope.showReCaptcha = response;
                if (scope.showReCaptcha) {
                    googleCaptchaService.loadReCaptcha();
                }
            });

            scope.selected = {
                receiveProduct: null,
                deliveryDay: {
                    value: '',
                    label: 'Choose a delivery day'
                },
                deliveryTime: {
                    value: '',
                    label: 'Choose delivery time'
                },
                orderNumber: null,
                firstName: shopperService.currentUser.firstName,
                lastName: shopperService.currentUser.lastName,
                email: shopperService.currentUser.email,
                contactNumber: shopperService.currentUser.phone,
                preferContactMethod: 'email_pcm',
                comment: { body: '' }
            };


            scope.options = {
                deliveryDays: null,
                deliveryTimes: null,
                closedDays: null,
                noSlots: ['Time slots are not available']
            };

            scope.selectReceiveProduct = (option) => {
                scope.selected.receiveProduct = option;
                //Clear the delivery timeframes
                scope.selected.deliveryDay = {
                    value: '',
                    label: 'Choose a delivery day'
                };

                scope.selected.deliveryTime = {
                    value: '',
                    label: 'Choose delivery time'
                };
            };

            missedDeliveryService.setReDeliveryCutOff(function () {
                scope.options.closedDays = missedDeliveryService.getClosedDays();
            });

            scope.options.deliveryDays = missedDeliveryService.getDeliveryDays();


            scope.changeDeliveryDay = (option) => {
                scope.selected.deliveryDay = option;
                scope.selected.deliveryTime = {
                    value: '',
                    label: 'Choose delivery time'
                };
                scope.options.deliveryTimes = missedDeliveryService.getDeliveryTimes(scope.selected.deliveryDay.value);
            };

            //Delivery Time
            scope.changeDeliveryTime = (option) => {
                scope.selected.deliveryTime = option;
            };

            scope.selectPreferredContactMethod = (preferedContactMethod) => {
                scope.selected.preferContactMethod = preferedContactMethod;
            };

            scope.checkDropDownValidity = (field) => {
                if (scope.missedDeliveryForm.$submitted && scope.selected.receiveProduct === 'reDeliver') {
                    if (field === 'deliveryDay') {
                        return scope.selected.deliveryDay.label === 'Choose a delivery day';
                    } else if (field === 'deliveryTime') {
                        return scope.selected.deliveryTime.label === 'Choose delivery time';
                    }
                }
            };

            scope.submitForm = function () {
                $timeout(function () {
                    if (scope.selected.receiveProduct === 'reDeliver') {
                        if (scope.checkDropDownValidity('deliveryDay') || scope.checkDropDownValidity('deliveryTime')) {
                            window.scrollTo(0, 0);
                            return;
                        }
                        scope.options.isTimeSlotExpire = missedDeliveryService.isTimeSlotExpire(scope.selected.deliveryDay.value, scope.selected.deliveryTime.value);
                    }
                    if (!scope.missedDeliveryForm.$valid) {
                        window.scrollTo(600, 600);
                        return;
                    }

                    if (window.grecaptcha && scope.showReCaptcha) {
                        scope.missedDeliveryForm.GoogleReCaptchaResponse = window.grecaptcha.getResponse();
                    }
                    if (scope.showReCaptcha) {
                        googleCaptchaService.validategooglecaptcha(scope.missedDeliveryForm).then(function (res) {
                            const { Success, FieldErrors } = res;
                            if (!Success) {
                                scope.missedDeliveryValidationErrors = FieldErrors;
                                scope.showReCaptchaErrorMessage = true;
                                if (window.grecaptcha && scope.showReCaptcha) {
                                    window.grecaptcha.reset();
                                }
                                return;
                            }
                            if (Success) scope.showReCaptchaErrorMessage = false;
                            scope.submitMissedDeliveryForm();
                        });
                    } else {
                        scope.submitMissedDeliveryForm();
                    }
                }, 0);
            };

            scope.submitMissedDeliveryForm = function () {

                scope.loading = true;
                missedDeliveryService.submitForm(scope.selected)
                    .then((response) => {
                        if (!!response.data && response.data.error) {
                            scope.errorOnSubmit();
                        } else if (response.data.ticket && response.data.ticket.id) {
                            scope.resheduleDeliveryReferenceNumber = response.data.ticket.id;
                        } else {
                            scope.showError = true;
                            console.error("Response data does not contain a ticket ID.");
                        }
                        scope.loading = false;
                        window.scrollTo(0, 0);
                    }, () => {
                        scope.errorOnSubmit();
                        scope.loading = false;
                        window.scrollTo(0, 0);
                    });
            };

            scope.errorOnSubmit = () => {
                scope.showError = true;
                if (window.grecaptcha && scope.showReCaptcha) {
                    window.grecaptcha.reset();
                }
            };
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/misseddelivery/misseddelivery-directives.js
 **/